'use strict';

export default {
  formList: {
    columns: {
      formName: 'Nom du formulaire',
      submission: 'Soumission(s)',
      status: 'Statut',
      lastUpdate: 'Dernière modification',
      editedBy: 'Édité par',
      active: 'Actif',
      pending: 'En attente',
      complete: 'Complété',
      draft: 'Brouillon',
      actions: 'Actions',
      archived: 'Archivé',
    },
    buttons: {
      editForm: 'Modifier le formulaire',
      preview: 'Prévisualiser le formulaire',
      view: 'Voir/Modifier',
      submissions: 'Voir les soumissions',
      addItem: '+ Ajouter un item',
      createForm: 'Créer formulaire',
      returnToForms: 'Revenir aux formulaires',
      delete: 'Supprimer le formulaire',
      cloneForm: 'Cloner',
      archive: 'Archiver',
      unarchive: 'Désarchiver',
    },
    deleteModal: {
      deleteModalHeader: 'Attention!',
      deleteConfirmation: 'Voulez-vous vraiment supprimer ce formulaire?',
    },
    archiveModal: {
      archiveModalHeader: 'Archiver le formulaire',
      archiveConfirmation: 'Êtes-vous sûr de vouloir archiver ce formulaire?',
    },
    createNewFormModal: {
      header: 'Créer un nouveau formulaire',
      formName: 'Nom du Formulaire',
      template: 'Modèle',
      emptyFormName: 'Veuillez donner un nom valide au formulaire',
      emptyLanguage: 'Veuillez choisir au moins une langue',
    },
    cloneFormModal: {
      header: 'Créer un nouveau formulaire',
      formName: 'Nom du Formulaire',
      emptyFormName: 'Veuillez donner un nom valide au formulaire',
      copy: 'Copie',
    },
    resendEmailModal: {
      sendSubmissionEmail: 'Renvoyer le courriel de soumission',
      email: 'Courriel',
      send: 'Envoyer',
    },
    submission: {
      currentSubmission: 'Soumission Actuelle: ',
      formId: 'Numéro du Formulaire: ',
      submissionId: 'Numéro de la Soumission: ',
      sentDate: "Date d'envoi: ",
      paymentStatus: 'Status Du Paiement: ',
      edit: 'Modifier',
      save: 'Sauvegarder',
      cancel: 'Annuler',
      summary: 'Résumé',
      noFields: 'Aucun Champs',
      submit: 'Soumettre',
      updateSuccess: 'Soumission mise à jour avec succès',
      updateError: 'Erreur lors de la mise à jour de la soumission',
      deleteSuccess: 'Soumission supprimer avec succès',
      modalTitle: 'Supprimer Soumission',
      modalMessage: 'Êtes-vous certain de vouloir supprimer cette soumission ?',
      noSubmissions: "Il n'y pas de soumissions pour ce formulaire",
      view: 'Voir/Modifier',
      formName: 'Nom du formulaire:',
      refund: 'Remboursement',
      refundError: 'Erreur lors du remboursement',
      refundSuccess: 'Le remboursement a été effectué avec succès',
      refundAmount: 'Montant à rembourser',
      refundAmountError: 'Montant plus grand que la valeur du paiement',
      refundStripeFees: 'Rembourser les frais Stripe',
      confirm: 'Confirmer',
      chooseRefundAmount: 'Choisir montant du remboursement',
      cancelPayment: 'Annuler paiement',
      cancelSuccess: 'Paiement annulé avec succès',
      cancelError: "Erreur lors de l'annulation du paiement",
      confirmCancelPayment: 'Voulez-vous annuler ce paiement ?',
      otherMethod: 'Autre méthode de paiement',
      total: 'Total',
      discount: 'Rabais',
    },
    refundHeaders: {
      paymentIntentId: 'ID de paiement',
      paymentTotal: 'Paiement total',
      stripeFees: 'Frais Stripe',
      status: 'Statut',
    },
    forms: {
      noForms: "Il n'y pas de formulaires pour cette organisation",
    },
    templates: {
      blank: 'Vierge',
      contact: 'Contactez-nous',
    },
  },
};
